import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Button } from '@beef/ui-kit';

import { getFeedbackPostsAdvanced } from 'store/ProductDetails/selectors';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import { FiveStarRate } from 'bricks';
import { scrollToFeedbackForm } from 'store/ProductDetails/common/actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function FeedbackSum({ items, isMobile, onClick }) {
  let ratingSum = 0;
  let ratingCount = 0;

  const [rating, setRating] = useState(5);

  useEffect(() => {
    items.forEach((item) => {
      ratingSum += item.rating || 5;
      ratingCount += 1;
    });
    if (ratingCount !== 0) {
      const ratingFinal = (ratingSum / ratingCount).toFixed(1);
      setRating(ratingFinal);
    } else {
      setRating(5);
    }
  }, [items]);

  return (
    <div className={cx('feedbackSum', isMobile && 'mobile')}>
      <div className={cx('feedbackRow')}>
        <div className={cx('ratingWrap')}>
          <span className={cx('rating')}>{rating}</span>
          &nbsp;/&nbsp;5
          <span className={cx('fiveStarRate')}>
            <FiveStarRate value={rating} />
          </span>
        </div>
      </div>
      <Button onClick={onClick} variant="tertiary" size="m">
        Написать отзыв
      </Button>
    </div>
  );
}

FeedbackSum.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      likes: PropTypes.number,
      dislikes: PropTypes.number,
      rating: PropTypes.number,
      publishDate: PropTypes.string,
      text: PropTypes.string,
      userName: PropTypes.string,
      isLiked: PropTypes.bool,
      idDisliked: PropTypes.bool,
      isRated: PropTypes.bool,
      title: PropTypes.string,
    }),
  ),
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  items: getFeedbackPostsAdvanced(state),
  isMobile: isScreenBelow1004(state),
  onClick: scrollToFeedbackForm,
});

const mapDispatchToProps = {
  onClick: scrollToFeedbackForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackSum);
